module.exports = __webpack_public_path__ + "img/index-about-building.23252045.png";